import 'bootstrap/dist/css/bootstrap.min.css'
import '@mdi/font/css/materialdesignicons.min.css'

import './src/static/styles/styles.css'
import './src/static/styles/animate.css'

